import { compactFormat, granularity, legendPosition, palette, showItems } from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.OVERTIME],
  title: "100% Stacked Area Chart",
  defaultHeight: 6,
  controls: [granularity],
  settings: {
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    palette,
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "displayMetric",
    },
    decompositionMetric: {
      default: "month",
      type: "select",
      label: "Decomposition Metric 1",
      dictionary: "timeMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    decompositionMetricTop: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric 2",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "spend",
      type: "select",
      label: "Display Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },
  },
  planSettings: {
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },

    palette,
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "displayMetric",
    },
    decompositionMetric: {
      default: "month",
      type: "select",
      label: "Decomposition Metric 1",
      dictionary: "timeMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    decompositionMetricTop: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric 2",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "channel_budget",
      type: "select",
      label: "Display Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },
  },
};
